import { render, staticRenderFns } from "./GeoStudentStops.vue?vue&type=template&id=6348b66a&scoped=true&"
import script from "./GeoStudentStops.vue?vue&type=script&lang=js&"
export * from "./GeoStudentStops.vue?vue&type=script&lang=js&"
import style0 from "./GeoStudentStops.vue?vue&type=style&index=0&id=6348b66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6348b66a",
  null
  
)

export default component.exports